import { FC } from 'react';
import { Outlet } from 'react-router-dom';
import styles from './AuthLayout.module.css';

/**
 * AuthLayout Component
 * Layout for authentication pages (login, register, etc.)
 */
const AuthLayout: FC = () => {
  return (
    <div className={styles.authLayout}>
      <div className={styles.container}>
        <div className={styles.logoSection}>
          <div className={styles.logo}>
            <h1 className={styles.title}>ALZ Token Portal</h1>
            <p className={styles.subtitle}>Enterprise Token Management</p>
          </div>
        </div>
        
        <div className={styles.contentSection}>
          <Outlet />
        </div>
      </div>
      
      <div className={styles.background}>
        <div className={styles.pattern}></div>
      </div>
    </div>
  );
};

export default AuthLayout;